"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.simpleDoctorAttendingApiSchema = exports.workSchedulesSchema = exports.workScheduleItem = exports.workSchedulesFrequencies = exports.workSchedulesDays = void 0;
const zod_1 = require("zod");
const api_1 = require("../global/api");
exports.workSchedulesDays = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
];
exports.workSchedulesFrequencies = ['weekly', 'every-2-weeks'];
exports.workScheduleItem = zod_1.z.object({
    day: zod_1.z.enum(exports.workSchedulesDays),
    between: zod_1.z.object({
        start: zod_1.z.number().min(0).max(24),
        end: zod_1.z.number().min(0).max(24),
    }),
    frequency: zod_1.z.enum(exports.workSchedulesFrequencies),
});
exports.workSchedulesSchema = zod_1.z.array(exports.workScheduleItem);
exports.simpleDoctorAttendingApiSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: (0, api_1.apiEntityTypeSchema)('doctor-attendings'),
    attributes: zod_1.z.object({
        firstname: zod_1.z.string(),
        lastname: zod_1.z.string(),
    }),
});
